module.exports = __webpack_public_path__ + "static/media/24.19f6f7d5.jpg";